module.exports = __webpack_public_path__ + "media/images/flags/do-045d888f7bd09308e5c5b1ed0fae957c.svg";